module.exports = __webpack_public_path__ + "static/media/sector-4.7e7ca063.jpg";